<ion-header>
  <ion-toolbar mode="ios">
    <ion-title>{{'Settings' | translation}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-list class="pty-list-fix-line">
    <ion-item>
      <ion-select label="{{'BibleVersion' | translation}}" label-placement="floating" placeholder="{{'SelectOne' | translation}}" [(ngModel)]="selectedBible" (ionChange)="bibleSelected($event)">
        <ion-select-option *ngFor="let item of bibles" [value]="item.uuid">{{item.name}}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer class="ion-text-center">
  <ion-button (click)="saveSettings()">
    {{'SaveSettings' | translation}}
  </ion-button>
</ion-footer>